(function () {
  var SELECTOR = '[data-hero-slideshow]';
  var MOBILE_QUERY = '(max-width: 749px)';
  var instances = [];

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function HeroSlideshow(root) {
    this.root = root;
    this.viewport = root.querySelector('[data-hero-slideshow-viewport]');
    this.slides = toArray(root.querySelectorAll('[data-hero-slideshow-slide]'));
    this.dots = toArray(root.querySelectorAll('[data-hero-slideshow-dot]'));
    this.prevBtn = root.querySelector('[data-hero-slideshow-prev]');
    this.nextBtn = root.querySelector('[data-hero-slideshow-next]');
    this.status = root.querySelector('[data-hero-slideshow-status]');
    this.index = 0;
    this.timer = null;
    this.touchStartX = 0;
    this.touchDeltaX = 0;
    this.autoplay = root.getAttribute('data-autoplay') === 'true' && this.slides.length > 1;
    this.speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    this.pauseOnHover = root.getAttribute('data-pause-hover') !== 'false';
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.bound = {};

    if (!this.viewport || this.slides.length === 0) return;

    this.bind();
    this.goTo(0, true);
    this.start();
  }

  HeroSlideshow.prototype.bind = function () {
    var self = this;

    this.bound.next = function () {
      self.goTo(self.index + 1);
      self.start();
    };
    this.bound.prev = function () {
      self.goTo(self.index - 1);
      self.start();
    };
    this.bound.resize = function () {
      self.updateHeight();
      self.syncVideos();
    };
    this.bound.visibility = function () {
      if (document.hidden) {
        self.stop();
      } else {
        self.start();
        self.syncVideos();
      }
    };
    this.bound.touchStart = function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      self.touchStartX = event.changedTouches[0].screenX;
      self.touchDeltaX = 0;
    };
    this.bound.touchEnd = function (event) {
      if (!event.changedTouches || !event.changedTouches[0]) return;
      self.touchDeltaX = self.touchStartX - event.changedTouches[0].screenX;
      if (Math.abs(self.touchDeltaX) < 50 || self.slides.length < 2) return;
      if (self.touchDeltaX > 0) {
        self.goTo(self.index + 1);
      } else {
        self.goTo(self.index - 1);
      }
      self.start();
    };
    this.bound.key = function (event) {
      if (self.slides.length < 2) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.goTo(self.index + 1);
        self.start();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.goTo(self.index - 1);
        self.start();
      }
    };
    this.bound.enter = function () {
      self.stop();
    };
    this.bound.leave = function (event) {
      if (event && event.relatedTarget && self.root.contains(event.relatedTarget)) return;
      self.start();
    };

    if (this.nextBtn) this.nextBtn.addEventListener('click', this.bound.next);
    if (this.prevBtn) this.prevBtn.addEventListener('click', this.bound.prev);

    this.dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        self.goTo(index);
        self.start();
      });
    });

    this.root.addEventListener('touchstart', this.bound.touchStart, { passive: true });
    this.root.addEventListener('touchend', this.bound.touchEnd, { passive: true });
    this.root.addEventListener('keydown', this.bound.key);

    if (this.pauseOnHover && this.autoplay) {
      this.root.addEventListener('mouseenter', this.bound.enter);
      this.root.addEventListener('mouseleave', this.bound.leave);
      this.root.addEventListener('focusin', this.bound.enter);
      this.root.addEventListener('focusout', this.bound.leave);
    }

    window.addEventListener('resize', this.bound.resize);
    document.addEventListener('visibilitychange', this.bound.visibility);

    this.mediaLoadUnbinders = [];
    this.slides.forEach(function (slide) {
      toArray(slide.querySelectorAll('img, video')).forEach(function (media) {
        var onReady = function () {
          if (slide.classList.contains('is-active')) self.updateHeight();
        };
        media.addEventListener('load', onReady);
        media.addEventListener('loadedmetadata', onReady);
        self.mediaLoadUnbinders.push(function () {
          media.removeEventListener('load', onReady);
          media.removeEventListener('loadedmetadata', onReady);
        });
      });
    });

    if (typeof ResizeObserver === 'function') {
      this.resizeObserver = new ResizeObserver(function () {
        self.updateHeight();
      });
      this.slides.forEach(function (slide) {
        self.resizeObserver.observe(slide);
      });
    }
  };

  HeroSlideshow.prototype.visibleMedia = function (slide) {
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;
    var mobile = slide.querySelector('.hero-slideshow__media--mobile');
    var desktop = slide.querySelector('.hero-slideshow__media--desktop');
    var all = slide.querySelector('.hero-slideshow__media--all');
    if (all) return all;
    if (isMobile && mobile) return mobile;
    return desktop || mobile;
  };

  HeroSlideshow.prototype.updateHeight = function () {
    var slide = this.slides[this.index];
    if (!slide || !this.viewport) return;
    var media = this.visibleMedia(slide) || slide;
    var height = media.offsetHeight || slide.offsetHeight;
    if (height > 0) {
      this.viewport.style.height = height + 'px';
      this.root.classList.add('is-ready');
    }
  };

  HeroSlideshow.prototype.syncVideos = function () {
    var self = this;
    var isMobile = window.matchMedia(MOBILE_QUERY).matches;

    this.slides.forEach(function (slide, index) {
      toArray(slide.querySelectorAll('video')).forEach(function (video) {
        var wrapper = video.closest('.hero-slideshow__media');
        var isMobileMedia = wrapper && wrapper.classList.contains('hero-slideshow__media--mobile');
        var isDesktopMedia = wrapper && wrapper.classList.contains('hero-slideshow__media--desktop');
        var isAllMedia = wrapper && wrapper.classList.contains('hero-slideshow__media--all');
        var isVisibleBreakpoint = isAllMedia || (isMobile ? isMobileMedia || !isDesktopMedia : isDesktopMedia || !isMobileMedia);
        var shouldPlay = index === self.index && isVisibleBreakpoint && !document.hidden;

        if (shouldPlay) {
          video.muted = true;
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
        } else {
          video.pause();
        }
      });
    });
  };

  HeroSlideshow.prototype.goTo = function (index, instant) {
    var count = this.slides.length;
    if (count === 0) return;

    index = ((index % count) + count) % count;
    this.index = index;

    if (instant && this.reducedMotion === false) {
      this.root.style.setProperty('--hs-duration', '0ms');
    }

    this.slides.forEach(function (slide, i) {
      var active = i === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) {
        slide.removeAttribute('inert');
      } else {
        slide.setAttribute('inert', '');
      }
    });

    this.dots.forEach(function (dot, i) {
      var active = i === index;
      dot.classList.toggle('is-active', active);
      if (active) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    if (this.status) {
      this.status.textContent = 'Slide ' + (index + 1) + ' of ' + count;
    }

    this.updateHeight();
    this.syncVideos();

    if (instant) {
      var self = this;
      window.requestAnimationFrame(function () {
        self.root.style.removeProperty('--hs-duration');
      });
    }
  };

  HeroSlideshow.prototype.start = function () {
    var self = this;
    this.stop();
    if (!this.autoplay || this.slides.length < 2 || this.reducedMotion) return;
    this.timer = window.setInterval(function () {
      self.goTo(self.index + 1);
    }, this.speed);
  };

  HeroSlideshow.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  HeroSlideshow.prototype.destroy = function () {
    this.stop();
    if (this.nextBtn) this.nextBtn.removeEventListener('click', this.bound.next);
    if (this.prevBtn) this.prevBtn.removeEventListener('click', this.bound.prev);
    this.root.removeEventListener('touchstart', this.bound.touchStart);
    this.root.removeEventListener('touchend', this.bound.touchEnd);
    this.root.removeEventListener('keydown', this.bound.key);
    this.root.removeEventListener('mouseenter', this.bound.enter);
    this.root.removeEventListener('mouseleave', this.bound.leave);
    this.root.removeEventListener('focusin', this.bound.enter);
    this.root.removeEventListener('focusout', this.bound.leave);
    window.removeEventListener('resize', this.bound.resize);
    document.removeEventListener('visibilitychange', this.bound.visibility);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.mediaLoadUnbinders) {
      this.mediaLoadUnbinders.forEach(function (unbind) {
        unbind();
      });
    }
    this.root.classList.remove('is-ready');
  };

  function initRoot(root) {
    if (!root || root.dataset.heroSlideshowReady === 'true') return;
    root.dataset.heroSlideshowReady = 'true';
    var instance = new HeroSlideshow(root);
    instances.push({ root: root, instance: instance });
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    toArray(context.querySelectorAll(SELECTOR)).forEach(initRoot);
    if (context.matches && context.matches(SELECTOR)) initRoot(context);
  }

  function destroyRoot(root) {
    instances = instances.filter(function (entry) {
      if (entry.root !== root) return true;
      if (entry.instance && entry.instance.destroy) entry.instance.destroy();
      delete root.dataset.heroSlideshowReady;
      return false;
    });
  }

  function findInstance(root) {
    for (var i = 0; i < instances.length; i += 1) {
      if (instances[i].root === root) return instances[i].instance;
    }
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    toArray(event.target.querySelectorAll(SELECTOR)).forEach(destroyRoot);
  });

  document.addEventListener('shopify:section:select', function (event) {
    var root = event.target.querySelector(SELECTOR);
    var instance = root ? findInstance(root) : null;
    if (instance) instance.stop();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    var root = event.target.querySelector(SELECTOR);
    var instance = root ? findInstance(root) : null;
    if (instance) instance.start();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-hero-slideshow-slide]');
    var root = event.target.closest(SELECTOR);
    var instance = root ? findInstance(root) : null;
    if (!instance || !slide) return;
    var index = instance.slides.indexOf(slide);
    if (index >= 0) {
      instance.stop();
      instance.goTo(index);
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest(SELECTOR);
    var instance = root ? findInstance(root) : null;
    if (instance) instance.start();
  });
})();
